var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlantIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.17848 12.3787C9.3144 11.9909 12.3535 15.0305 11.9659 19.1679C7.82856 19.5555 4.78992 16.5171 5.17848 12.3787Z",
    fill: "#23AE5E",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87528 14.076C9.97752 13.7849 12.2568 16.0647 11.9659 19.1679C8.8632 19.459 6.58416 17.1795 6.87528 14.076Z",
    fill: "#A4C539",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88344 7.48413C9.98568 7.19277 12.265 9.47277 11.9743 12.576C8.87136 12.8666 6.59232 10.5878 6.88344 7.48413Z",
    fill: "#23AE5E",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15592 8.7571C10.4825 8.53894 12.1922 10.2487 11.9743 12.576C9.6468 12.7937 7.93776 11.0851 8.15592 8.7571Z",
    fill: "#A4C539",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17848 12.3787C5.15016 12.6801 5.14224 12.9744 5.1492 13.2631C8.43912 13.0603 11.0484 14.8668 11.9542 17.6604C11.5706 14.3179 8.79312 12.0393 5.17848 12.3787Z",
    fill: "#1C9952"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87528 14.0755C6.84696 14.3784 6.8436 14.6731 6.86256 14.959C9.29736 14.839 11.2358 16.153 11.971 18.1925C11.7528 15.6022 9.64224 13.8158 6.87528 14.0755Z",
    fill: "#8DAC31"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88344 7.48418C6.85488 7.7873 6.85176 8.08202 6.87048 8.36786C9.30528 8.24786 11.2438 9.56186 11.9789 11.6016C11.761 9.01034 9.6504 7.22474 6.88344 7.48418Z",
    fill: "#1C9952"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15592 8.7576C8.12712 9.06456 8.13384 9.36 8.16936 9.64248C9.9528 9.58752 11.3818 10.5283 11.9837 11.9957C11.8906 9.97272 10.2838 8.55792 8.15592 8.7576Z",
    fill: "#8DAC31"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8213 12.3794C19.2098 16.5151 16.1705 19.5554 12.0322 19.1669C11.6453 15.03 14.6839 11.9909 18.8213 12.3794Z",
    fill: "#23AE5E",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8213 12.3794C18.5201 12.3511 18.2256 12.3432 17.9369 12.3502C18.1397 15.6401 16.3337 18.2491 13.5396 19.1551C16.8821 18.7718 19.1609 15.9941 18.8213 12.3794Z",
    fill: "#1C9952"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1163 7.48463C17.4074 10.5869 15.1279 12.8664 12.0238 12.5753C11.7336 9.47231 14.0124 7.19327 17.1163 7.48463Z",
    fill: "#23AE5E",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1163 7.48462C16.8132 7.45606 16.5185 7.45294 16.2329 7.47166C16.3526 9.90647 15.0386 11.8447 12.9986 12.5803C15.5904 12.3621 17.376 10.2513 17.1163 7.48462Z",
    fill: "#1C9952"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C13.5991 4.32504 13.5991 6.47424 11.9993 7.79976C10.3992 6.47424 10.3992 4.32552 12 3Z",
    fill: "#23AE5E",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C11.8925 3.08928 11.7931 3.18264 11.7 3.27888C12.8974 4.51512 12.8974 6.28416 11.6993 7.52064C11.7926 7.61688 11.8915 7.71048 11.9993 7.79952C13.5989 6.47424 13.5989 4.32504 12 3Z",
    fill: "#1C9952"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 4.20001C13.1988 5.19337 13.1988 6.80569 11.9993 7.80001C10.7998 6.80569 10.7988 5.19433 11.9993 4.20001Z",
    fill: "#A4C539",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 4.20001C11.8874 4.29241 11.79 4.39153 11.6993 4.49353C12.4942 5.38705 12.4942 6.61177 11.6993 7.50601C11.79 7.60825 11.8874 7.70761 11.9993 7.80001C13.1986 6.80569 13.1986 5.19337 11.9993 4.20001Z",
    fill: "#8DAC31"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 7.79974V21",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1247 14.076C17.4158 17.1785 15.1363 19.458 12.0331 19.1669C11.7418 16.0639 14.0206 13.7851 17.1247 14.076Z",
    fill: "#A4C539",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1247 14.076C16.8218 14.0477 16.5274 14.0443 16.2415 14.0633C16.3613 16.4983 15.0473 18.4366 13.0075 19.1714C15.5983 18.9538 17.3844 16.843 17.1247 14.076Z",
    fill: "#8DAC31"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8431 8.75711C16.0615 11.0839 14.3513 12.7934 12.0238 12.5753C11.8066 10.248 13.5151 8.53895 15.8431 8.75711Z",
    fill: "#A4C539",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8431 8.75714C15.5364 8.72834 15.2407 8.73506 14.9582 8.77034C15.0132 10.5538 14.0722 11.983 12.6048 12.5849C14.628 12.4918 16.0428 10.885 15.8431 8.75714Z",
    fill: "#8DAC31"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8213 12.3794C19.2098 16.5151 16.1705 19.5554 12.0322 19.1669C11.6453 15.03 14.6839 11.9909 18.8213 12.3794Z",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1247 14.076C17.4158 17.1785 15.1363 19.458 12.0331 19.1669C11.7418 16.0639 14.0206 13.7851 17.1247 14.076Z",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1163 7.48463C17.4074 10.5869 15.1279 12.8664 12.0238 12.5753C11.7336 9.47231 14.0124 7.19327 17.1163 7.48463Z",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8431 8.75711C16.0615 11.0839 14.3513 12.7934 12.0238 12.5753C11.8066 10.248 13.5151 8.53895 15.8431 8.75711Z",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C13.5991 4.32504 13.5991 6.47424 11.9993 7.79976C10.3992 6.47424 10.3992 4.32552 12 3Z",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 4.20001C13.1988 5.19337 13.1988 6.80569 11.9993 7.80001C10.7998 6.80569 10.7988 5.19433 11.9993 4.20001Z",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17848 12.3787C9.3144 11.9902 12.3545 15.0298 11.9662 19.1679C7.82904 19.555 4.78992 16.5166 5.17848 12.3787Z",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87528 14.0755C9.97752 13.7844 12.257 16.0642 11.9662 19.1674C8.8632 19.4585 6.58416 17.1794 6.87528 14.0755Z",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88344 7.48418C9.98568 7.1933 12.265 9.47282 11.9743 12.5767C8.87136 12.8671 6.59184 10.5883 6.88344 7.48418Z",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15592 8.75763C10.4825 8.53923 12.1922 10.2492 11.9743 12.5767C9.6468 12.7944 7.93776 11.0851 8.15592 8.75763Z",
    stroke: "#503B2D",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantIcon1);
export default __webpack_public_path__ + "static/media/PlantIcon1.22e3b9f07105c8f8f6f6839ac6783617.svg";
export { ForwardRef as ReactComponent };